import config from 'config'
import { Route } from 'vue-router'
import rootStore from '@vue-storefront/core/store'
import { storeCode as getStoreCode } from '@vue-storefront/core/lib/multistore'

function stripTrailingSlashes (url: string): string {
  return url.replace(/\/+$/, '')
}

/**
 * Build CMS sync URL without duplicate slashes (guests have empty user token).
 * Path shape: {cms}/vue/cart/sync/token/{userToken}/cart/{cartToken}
 */
export function getMagentoCartSyncUri (cmsUrl: string, routeTo: Route): string {
  const base = stripTrailingSlashes(cmsUrl)
  const userToken = rootStore.state.user.token || 'null'
  const cartToken = rootStore.state.cart.cartServerToken || ''
  let uri = `${base}/vue/cart/sync/token/${userToken}/cart/${cartToken}`
  if (typeof routeTo.params.paypal !== 'undefined') {
    uri += '?paypal=1'
  }
  return uri
}

function resolveCmsBaseForStore (): string | null {
  const externalCheckoutConfig = { ...config.externalCheckout }
  const cmsUrl: string = externalCheckoutConfig.cmsUrl
  const stores = externalCheckoutConfig.stores
  const storeCode = getStoreCode()
  const multistoreEnabled: boolean = config.storeViews.multistore

  if (multistoreEnabled && stores && typeof stores === 'object' && storeCode in stores) {
    const u = stores[storeCode] && stores[storeCode].cmsUrl
    if (typeof u === 'string' && u.length > 0) {
      return u
    }
  }
  if (typeof cmsUrl === 'string' && cmsUrl.length > 0) {
    return cmsUrl
  }
  return null
}

function isVsfCheckoutRoute (to: Route, storeCode: string, multistore: boolean): boolean {
  const pathOnly = (to.path || '').split(/[?#]/)[0].replace(/\/+$/, '') || '/'
  if (pathOnly === '/checkout') {
    return true
  }
  if (to.name === 'checkout') {
    return true
  }
  if (multistore && to.name === `${storeCode}-checkout`) {
    return true
  }
  return false
}

export function beforeEach (to: Route, from: Route, next) {
  const storeCode = getStoreCode()
  const multistoreEnabled: boolean = config.storeViews.multistore

  if (!isVsfCheckoutRoute(to, storeCode, multistoreEnabled)) {
    return next()
  }

  const cmsBase = resolveCmsBaseForStore()
  if (!cmsBase) {
    return next()
  }

  const uri = getMagentoCartSyncUri(cmsBase, to)

  if (typeof window !== 'undefined' && window.location) {
    window.location.replace(uri)
    return
  }

  // SSR: avoid touching `window`; render a minimal shell (theme checkout route stub).
  return next()
}
